<mat-sidenav-container class="sidenav-container" autosize>
  @if (patient) {
    <mat-sidenav mode="side" opened [ngClass]="{ expanded: isSideNavOpen(), collapsed: !isSideNavOpen() }">
      <div class="side-nav-shell">
        @if (isSideNavOpen()) {
          <div class="search-ipt">
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <div class="search-inner">
                <app-icon name="search" size="sm" color="on-surface-variant"></app-icon>
                <input
                  #desktopNavSearchInput
                  matInput
                  id="desktopNavSearch"
                  type="text"
                  [(ngModel)]="searchValue"
                  placeholder="What are you looking for?" />
                @if (searchValue !== '') {
                  <app-icon-button
                    icon="close"
                    size="xs"
                    ariaLabel="Clear Search"
                    color="on-surface-variant"
                    (clicked)="searchValue = ''"></app-icon-button>
                }
              </div>
            </mat-form-field>
          </div>
        }

        <div class="nav-list" role="list" data-test="desktop-nav-list" data-testid="desktop-nav-list">
          @if (!isSideNavOpen()) {
            <div
              class="nav-menu-item nav-menu-item--search"
              role="listitem"
              matTooltip="Search"
              [matTooltipDisabled]="isSideNavOpen()"
              matTooltipPosition="after">
              <button type="button" class="nav-menu-action" aria-label="Open search" (click)="openSearch()">
                <div class="nav-row">
                  <div class="nav-row-start">
                    <app-icon name="search" size="sm" color="on-primary"></app-icon>
                  </div>
                </div>
              </button>
            </div>
          }
          @for (navListItem of filteredNavList; track navListItem.name) {
            <div
              class="nav-menu-item"
              role="listitem"
              [matTooltip]="navListItem.name"
              [matTooltipDisabled]="isSideNavOpen()"
              matTooltipPosition="after">
              <div class="nav-menu-row">
                @if (hasRouteLink(navListItem)) {
                  <a
                    class="nav-menu-action nav-menu-action--main"
                    [class.nav-menu-action--active]="isItemActive(navListItem)"
                    [attr.aria-label]="navListItem.name"
                    [routerLink]="getRouteLink(navListItem)"
                    (click)="onMenuRouteLinkClicked(navListItem)">
                    <div class="nav-row">
                      <div class="nav-row-start">
                        @if (navListItem.icon) {
                          <app-icon [name]="navListItem.icon" size="md" color="on-primary"></app-icon>
                        }
                        @if (isSideNavOpen()) {
                          <p>{{ navListItem.name }}</p>
                        }
                      </div>
                    </div>
                  </a>
                } @else {
                  <button
                    type="button"
                    class="nav-menu-action nav-menu-action--main"
                    [class.nav-menu-action--active]="isItemActive(navListItem)"
                    [attr.aria-label]="navListItem.name"
                    (click)="menuItemClicked(navListItem)">
                    <div class="nav-row">
                      <div class="nav-row-start">
                        @if (navListItem.icon) {
                          <app-icon [name]="navListItem.icon" size="md" color="on-primary"></app-icon>
                        }
                        @if (isSideNavOpen()) {
                          <p>{{ navListItem.name }}</p>
                        }
                      </div>
                    </div>
                  </button>
                }
                @if (isSideNavOpen() && navListItem.subMenu?.length && !isSearchActive) {
                  <button
                    type="button"
                    class="nav-submenu-toggle"
                    [attr.aria-label]="isSubMenuExpanded(navListItem.name) ? 'Collapse submenu' : 'Expand submenu'"
                    [attr.aria-expanded]="isSubMenuExpanded(navListItem.name)"
                    (click)="toggleSubMenu(navListItem.name)">
                    <app-icon
                      [name]="isSubMenuExpanded(navListItem.name) ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
                      size="sm"
                      color="on-primary"></app-icon>
                  </button>
                }
              </div>
            </div>

            @if (shouldShowSubMenu(navListItem)) {
              <div class="sub-menu">
                @for (subMenuItem of navListItem.subMenu!; track subMenuItem.name) {
                  @if (hasRouteLink(subMenuItem)) {
                    <a
                      class="sub-menu-action"
                      [class.sub-menu-action--active]="isItemActive(subMenuItem)"
                      [attr.aria-label]="subMenuItem.name"
                      [routerLink]="getRouteLink(subMenuItem)">
                      <p>{{ subMenuItem.name }}</p>
                    </a>
                  } @else {
                    <button
                      type="button"
                      class="sub-menu-action"
                      [class.sub-menu-action--active]="isItemActive(subMenuItem)"
                      [attr.aria-label]="subMenuItem.name"
                      (click)="subMenuItemClicked(subMenuItem)">
                      <p>{{ subMenuItem.name }}</p>
                    </button>
                  }
                }
              </div>
            }
          }
        </div>

        <div class="side-nav-footer">
          <div class="toggle-wrap" [class.toggle-wrap--collapsed]="!isSideNavOpen()">
            <button
              type="button"
              class="nav-toggle-btn"
              (click)="toggleIsSideNavOpen($event)"
              [attr.aria-label]="isSideNavOpen() ? 'Collapse Navigation' : 'Expand Navigation'">
              <app-icon
                [name]="isSideNavOpen() ? 'keyboard_double_arrow_left' : 'keyboard_double_arrow_right'"
                size="sm"
                color="on-primary"></app-icon>
            </button>
          </div>
        </div>
      </div>
    </mat-sidenav>
  }
  <mat-sidenav-content class="sidenav-content">
    <!-- Mirrors .route-host in app.component: the routed page must be bounded by the viewport, not
         sized by its own content. Every page-host component reads height:100% off this element. -->
    <div class="sidenav-route-host">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
